<form (ngSubmit)="closeConfirmationDialog()" #f="ngForm" id="facebookConfirmationForm" class="facebook-confirmation-modal">

  <div class="modal-body pt-md-5 pb-md-5">
    <div class="form-group row mb-0 pt-2 pb-2">
      <ul [ngClass]="{'with-multiple-items': messages.length && messages.length > 1 }">
        <li *ngFor="let message of messages">
          {{message}}
        </li>
        <li *ngIf="this.messengerUrl">
          <br/> Opt-in to our Facebook Messenger program to receive tips and tools to make your Facebook Fundraiser successful.
        </li>
      </ul>
    </div>
  </div>
  <div class="modal-footer">
    <button form="facebookConfirmationForm" class="btn btn-primary" *ngIf="this.messengerUrl" (click)="openMessengerUrl()">Opt-In</button>
    <button form="facebookConfirmationForm" class="btn btn-primary" *ngIf="this.messengerUrl">No Thanks</button>
    <button form="facebookConfirmationForm" class="btn btn-primary" *ngIf="!this.messengerUrl">Ok</button>
  </div>
</form>
